<template>
<ul class="hidden md:block fixed right-6 bottom-10 z-20">
    <li class="py-2">
        <button type="button" class="w-[70px] h-[70px] relative group" v-scroll-to="'#requirements'">
            <img class=" w-[70px] h-[70px]" :src="publickPath + '/images/btn-bg-l.png'">
            <div class="absolute w-[70px] h-[70px] pointer-events-none -top-1 -left-1 text-xs font-bold rounded-full bg-lemon-normal flex justify-center items-center group-hover:top-0 group-hover:left-0 transition-all">
                募集要項<br>
                はコチラ
            </div>
        </button>
    </li>
    <li class="py-2">
        <a class="w-[70px] h-[70px] relative group inline-block" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeTOrYjlFQMeUi2pu_9X2enLOFKaWkhSx4VS7AR8blXUU_m1w/viewform?usp=sf_link">
            <img class=" w-[70px] h-[70px]" :src="publickPath + '/images/btn-bg-l.png'">
            <div class="absolute w-[70px] h-[70px] pointer-events-none -top-1 -left-1 text-xs font-bold rounded-full bg-lemon-normal flex justify-center items-center group-hover:top-0 group-hover:left-0 transition-all">
                応募する
            </div>
        </a>
    </li>
    <li class="py-2">
        <button type="button" class="w-[70px] h-[70px] relative group" v-scroll-to="'#first'">
            <img class=" w-[70px] h-[70px]" :src="publickPath + '/images/btn-bg-l.png'">
            <div class="absolute w-[70px] h-[70px] pointer-events-none -top-1 -left-1 border-2 border-lemon-normal rounded-full bg-white flex justify-center items-center text-lemon-normal group-hover:top-0 group-hover:left-0 transition-all">
                <svg class="mb-1" width="18" height="15" viewport="0,0,18,15">
                    <polygon fill="currentColor" points="0,15 9,0 18,15" />
                </svg>
            </div>
        </button>
    </li>
</ul>

<ul class="md:hidden fixed right-6 bottom-10 z-20">
    <li class="py-2">
        <button type="button" class="w-[53px] h-[53px] relative group" v-scroll-to="'#requirements'">
            <img class=" w-[53px] h-[53px]" :src="publickPath + '/images/btn-bg-s.png'">
            <div class="absolute w-[53px] h-[53px] pointer-events-none -top-[3px] -left-[3px] text-xs font-bold rounded-full bg-lemon-normal flex justify-center items-center group-hover:top-0 group-hover:left-0 transition-all">
                募集<br>要項
            </div>
        </button>
    </li>
    <li class="py-2">
        <a class="w-[53px] h-[53px] relative group inline-block" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeTOrYjlFQMeUi2pu_9X2enLOFKaWkhSx4VS7AR8blXUU_m1w/viewform?usp=sf_link">
            <img class=" w-[53px] h-[53px]" :src="publickPath + '/images/btn-bg-s.png'">
            <div class="absolute w-[53px] h-[53px] pointer-events-none -top-[3px] -left-[3px] text-xs font-bold rounded-full bg-lemon-normal flex justify-center items-center group-hover:top-0 group-hover:left-0 transition-all">
                応募<br>する
            </div>
        </a>
    </li>
    <li class="py-2">
        <button type="button" class="w-[53px] h-[53px] relative group" v-scroll-to="'#first'">
            <img class=" w-[53px] h-[53px]" :src="publickPath + '/images/btn-bg-s.png'">
            <div class="absolute w-[53px] h-[53px] pointer-events-none -top-[3px] -left-[3px] border-2 border-lemon-normal rounded-full bg-white flex justify-center items-center text-lemon-normal group-hover:top-0 group-hover:left-0 transition-all">
                <svg class="mb-1" width="18" height="15" viewport="0,0,18,15">
                    <polygon fill="currentColor" points="0,15 9,0 18,15" />
                </svg>
            </div>
        </button>
    </li>
</ul>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  computed: {
    publickPath() {
      if (process.env.NODE_ENV === 'production') {
        return '/recruit'
      } else {
        return ''
      }
    }
  }
}
</script>
